import { render } from "./ServiceLogo.vue?vue&type=template&id=647ffcf2&scoped=true"
import script from "./ServiceLogo.vue?vue&type=script&lang=js"
export * from "./ServiceLogo.vue?vue&type=script&lang=js"

import "./ServiceLogo.vue?vue&type=style&index=0&id=647ffcf2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647ffcf2"]])

export default __exports__